const { REACT_APP_PRODUCT_SEARCH_LAMBDA_API, REACT_APP_PRODUCT_SEARCH_ACCESS_TOKEN } = process.env;

export const productSearchApi = ({
  offset,
  limit,
  storeId,
  brandCd,
  keyword,
  sortType,
}) => {
  return {
    headers: {
      emcb_access_token: REACT_APP_PRODUCT_SEARCH_ACCESS_TOKEN,
    },
    apiUrl:
      REACT_APP_PRODUCT_SEARCH_LAMBDA_API +
      `/search/products?offset=${offset}&limit=${limit}&store_id=${storeId}&biztp=${brandCd}&search_term=${keyword}&sort_type=${sortType}`,
  };
};
